import { AiForecastItemDto, AiForecastResponse, AiMomentumDashboardResponse } from '../types';

export function forecastHorizons(
  forecast: AiForecastResponse,
  momentum: AiMomentumDashboardResponse,
): AiForecastItemDto[] {
  if (forecast.forecasts.length) {
    return [...forecast.forecasts].sort((a, b) => a.forecast_horizon - b.forecast_horizon);
  }

  return momentum.forecast_horizons.map((item) => ({
    forecast_horizon: item.horizon_days,
    anchor_date: momentum.anchor_date,
    forecast_date: '',
    projected_direction: null,
    confidence_band: 'Suppressed' as const,
    data_sufficiency_flag: false,
    suppression_message: item.suppression_message,
    projection_generated_at: momentum.generated_at,
  }));
}

export function isForecastDisclosed(item: AiForecastItemDto): boolean {
  return Boolean(item.data_sufficiency_flag && item.projected_direction);
}

export function forecastDirectionLabel(item: AiForecastItemDto): string {
  if (!isForecastDisclosed(item)) {
    return 'Suppressed';
  }

  return item.projected_direction as string;
}

export function forecastDirectionColor(direction?: string): string | undefined {
  if (direction === 'Improving') {
    return '#8bc34a';
  }

  if (direction === 'Declining') {
    return '#e57373';
  }

  return undefined;
}

export function forecastTone(item: AiForecastItemDto): { card: string; value: string } {
  if (!isForecastDisclosed(item)) {
    return {
      card: 'border-l-mid-grey bg-lime-grey/40',
      value: 'text-portal-teal/45',
    };
  }

  if (item.projected_direction === 'Improving') {
    return {
      card: 'border-l-coriander bg-lime-fg-light/70',
      value: 'text-lime-green-dark',
    };
  }

  if (item.projected_direction === 'Declining') {
    return {
      card: 'border-l-error-red bg-action-required/50',
      value: 'text-error-red',
    };
  }

  return {
    card: 'border-l-portal-teal bg-portal-header-wash/70',
    value: 'text-portal-teal',
  };
}
